// extracted by mini-css-extract-plugin
module.exports = {"apply":"style_apply__1X4ov","title":"style_title__jHDjs"};